// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.k_Gr34rArWgcmhlX3Jfj{color:var(--content-primary-primary);letter-spacing:.13923px;text-align:left;vertical-align:inherit;border:none;padding:0;font-size:13px;font-weight:400;line-height:1.43}.DfHD05nuoxhsrXNbz8gY{color:var(--content-primary-tertiary);font-weight:500;line-height:24px}.tTO9DxPwCpEG4IL11wDb{white-space:nowrap;text-overflow:ellipsis;align-content:center;min-height:40px;padding:0 8px;overflow:hidden}.aPI4DblbiXwFbRORMPgX{overflow:initial}.SIGCHbJTQdIk6Zz4Btoh{width:100%;height:100%;color:unset;text-decoration:none;display:block}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cell": `k_Gr34rArWgcmhlX3Jfj`,
	"cellHeader": `DfHD05nuoxhsrXNbz8gY`,
	"tableCell": `tTO9DxPwCpEG4IL11wDb`,
	"overflowInitial": `aPI4DblbiXwFbRORMPgX`,
	"link": `SIGCHbJTQdIk6Zz4Btoh`
};
export default ___CSS_LOADER_EXPORT___;
